import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30009ccc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "instruction-view" }
const _hoisted_2 = {
  key: 0,
  class: "iv-loading"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-secondary",
  role: "status"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "iv-head" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iv-eyebrow" }, "Eigene Unterweisung", -1))
const _hoisted_7 = { class: "iv-title" }
const _hoisted_8 = { class: "iv-file" }
const _hoisted_9 = { class: "iv-grid" }
const _hoisted_10 = { class: "iv-doc-col" }
const _hoisted_11 = { class: "iv-doc-card" }
const _hoisted_12 = {
  key: 0,
  class: "iv-tabs",
  role: "tablist"
}
const _hoisted_13 = ["aria-selected", "onClick"]
const _hoisted_14 = { class: "iv-tab-num" }
const _hoisted_15 = { class: "iv-tab-label" }
const _hoisted_16 = {
  key: 0,
  class: "iv-tab-check",
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 0,
  class: "iv-doc-loader"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-secondary",
  role: "status"
}, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = {
  key: 3,
  class: "iv-doc-fallback"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Dieses Dokument kann nicht direkt angezeigt werden.", -1))
const _hoisted_25 = ["href"]
const _hoisted_26 = {
  key: 0,
  class: "iv-scroll-hint"
}
const _hoisted_27 = {
  key: 1,
  class: "iv-doc-nav"
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "iv-confirm" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "iv-confirm-title" }, "Bitte bestätigen Sie die folgenden Punkte", -1))
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = { class: "iv-signature" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "iv-signature-label" }, "Digitale Unterschrift", -1))
const _hoisted_34 = { class: "iv-signature-name" }
const _hoisted_35 = {
  key: 0,
  class: "iv-scroll-hint"
}
const _hoisted_36 = {
  key: 1,
  class: "iv-error"
}
const _hoisted_37 = ["disabled"]
const _hoisted_38 = {
  key: 1,
  class: "iv-done"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "iv-done-badge" }, "Unterschrieben ✓", -1))
const _hoisted_40 = { class: "iv-done-text" }
const _hoisted_41 = { class: "iv-signature" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "iv-signature-label" }, "Digitale Unterschrift", -1))
const _hoisted_43 = { class: "iv-signature-name" }
const _hoisted_44 = {
  key: 2,
  class: "iv-loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_pdf_embed = _resolveComponent("vue-pdf-embed")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "iv-back",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
    }, "← Zurück"),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_ctx.instruction)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.instruction.title), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.sectionSummary), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  (_ctx.sections.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (sec, idx) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: 'tab' + idx,
                            type: "button",
                            class: _normalizeClass(["iv-tab", { active: _ctx.activeTab === idx, read: _ctx.readSections[idx] }]),
                            role: "tab",
                            "aria-selected": _ctx.activeTab === idx,
                            onClick: ($event: any) => (_ctx.activeTab = idx)
                          }, [
                            _createElementVNode("span", _hoisted_14, _toDisplayString(idx + 1), 1),
                            _createElementVNode("span", _hoisted_15, _toDisplayString(sec.title || sec.fileName), 1),
                            (_ctx.readSections[idx])
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_16, _hoisted_18))
                              : _createCommentVNode("", true)
                          ], 10, _hoisted_13))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.activeSection)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        ref: (el) => _ctx.setDocRef(el, _ctx.activeTab),
                        class: "iv-doc",
                        onScroll: _cache[2] || (_cache[2] = (e) => _ctx.onDocScroll(e, _ctx.activeTab))
                      }, [
                        (_ctx.docLoading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
                          : _createCommentVNode("", true),
                        (_ctx.activeSection.fileType === 'pdf' && _ctx.activeSection.fileUrl)
                          ? (_openBlock(), _createBlock(_component_vue_pdf_embed, {
                              key: 1,
                              source: _ctx.activeSection.fileUrl,
                              onRendered: _cache[1] || (_cache[1] = () => _ctx.onDocRendered(_ctx.activeTab)),
                              onLoadingFailed: _ctx.onDocFailed,
                              onRenderingFailed: _ctx.onDocFailed
                            }, null, 8, ["source", "onLoadingFailed", "onRenderingFailed"]))
                          : (_ctx.activeSection.fileType === 'md' && _ctx.activeSection.fileUrl)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: "iv-md md-doc",
                                innerHTML: _ctx.mdHtml[_ctx.activeTab] || ''
                              }, null, 8, _hoisted_22))
                            : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                _hoisted_24,
                                (_ctx.activeSection.fileUrl)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      href: _ctx.activeSection.fileUrl,
                                      target: "_blank",
                                      rel: "noopener",
                                      class: "btn-ghost"
                                    }, " Dokument herunterladen ", 8, _hoisted_25))
                                  : _createCommentVNode("", true)
                              ]))
                      ], 544))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.needsScrollForIdx(_ctx.activeTab) && !_ctx.readSections[_ctx.activeTab])
                  ? (_openBlock(), _createElementBlock("p", _hoisted_26, " Bitte lesen Sie dieses Dokument bis zum Ende. "))
                  : _createCommentVNode("", true),
                (_ctx.sections.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      (_ctx.activeTab > 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn-ghost",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeTab = _ctx.activeTab - 1))
                          }, "← Vorheriges"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_28)),
                      (_ctx.activeTab < _ctx.sections.length - 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: "btn-ghost",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.activeTab = _ctx.activeTab + 1))
                          }, "Nächstes →"))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_29, [
                (!_ctx.myConfirmation)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_30,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.confirmationItems, (item, idx) => {
                        return (_openBlock(), _createElementBlock("label", {
                          key: idx,
                          class: "iv-check"
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => ((_ctx.checked[idx]) = $event)
                          }, null, 8, _hoisted_31), [
                            [_vModelCheckbox, _ctx.checked[idx]]
                          ]),
                          _createElementVNode("span", null, _toDisplayString(item), 1)
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_32, [
                        _hoisted_33,
                        _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.signatureName), 1)
                      ]),
                      (!_ctx.allRead)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_35, " Bitte lesen Sie alle Dokumente bis zum Ende, um bestätigen zu können. "))
                        : _createCommentVNode("", true),
                      (_ctx.error)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(_ctx.error), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        class: "btn-primary iv-submit",
                        disabled: !_ctx.allChecked || _ctx.saving || !_ctx.allRead,
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
                      }, _toDisplayString(_ctx.saving ? 'Wird gespeichert …' : 'Bestätigen und unterschreiben'), 9, _hoisted_37)
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _hoisted_39,
                      _createElementVNode("p", _hoisted_40, " Sie haben diese Unterweisung am " + _toDisplayString(_ctx.formatDate(_ctx.myConfirmation.confirmedAt)) + " Uhr bestätigt. ", 1),
                      _createElementVNode("div", _hoisted_41, [
                        _hoisted_42,
                        _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.myConfirmation.signatureName), 1)
                      ]),
                      _createElementVNode("button", {
                        class: "btn-ghost",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.downloadCertificate && _ctx.downloadCertificate(...args)))
                      }, "Nachweis herunterladen")
                    ]))
              ])
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_44, "Unterweisung nicht gefunden."))
  ]))
}